import {Suspense, useEffect} from 'react'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import axios from 'axios'
import Swal from 'sweetalert2'
import {removeCookie} from './utils/cookie'
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'
import {MaintenanceDialog} from './modules/maintenance/MaintenanceDialog'

const App = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY

  useEffect(() => {
    // Add tab close handler
    const handleTabClose = () => {
      removeCookie('SESSION_ID')
    }
    window.addEventListener('beforeunload', handleTabClose)

    // Handle trailing slash
    if (location.pathname.endsWith('/')) {
      const newPath = location.pathname.slice(0, -1)
      navigate(newPath, {replace: true})
    }

    // Add axios interceptor
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 403) {
          await Swal.fire({
            title: error.response?.data?.error_desc || 'Session Expired',
            text: 'Please reload page again to continue',
            icon: 'warning',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
              removeCookie('SESSION_ID')
            }
          })
        } else if (error.response?.status === 401) {
          await Swal.fire({
            title: error.response?.data?.error_desc || 'Session Expired',
            text: 'Please reload page again to continue',
            icon: 'warning',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
              removeCookie('SESSION_ID')
            }
          })
        }
        return Promise.reject(error)
      }
    )

    // Cleanup interceptor and event listener on unmount
    return () => {
      axios.interceptors.response.eject(interceptor)
      window.removeEventListener('beforeunload', handleTabClose)
    }
  }, [location, navigate])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaKey || ''}
        language='vi'
        useRecaptchaNet={false}
        useEnterprise={false}
      >
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
            <MaintenanceDialog />
          </LayoutProvider>
        </I18nProvider>
      </GoogleReCaptchaProvider>
    </Suspense>
  )
}

export {App}
